import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import TextAreaInput from "../../common/TextAreaInput";
import RadioButtonChild from "../../common/RadioButtonWithChild";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import * as domainConstants from "../../../constants/DomainConstants";

const KwaliteitsontwikkelingEnInnovatieForm = props => {
    const INNOVATIE_TOOLTIP = "Maak een onderscheid volgens doelgroep, d.i. de door de Vlaamse overheid ondersteunde topsportprogramma’s per topsportfederatie (talentdetectie-, ontwikkelings- en/of prestatieprogramma’s).";
    const {
        beoordelingscriteria,
        disabled,
        errors,
        onChange,
        color,
        fileTypes,
        mapDeleteFile,
        mapDropFiles,
        getFilesForDossierComponent,
        fileSessionStarted,
        validationMessageType
    } = props;

    const sharedInputProps = {
        onChange: onChange,
        disabled: disabled
    };
    const sharedDownloadProps = {
        center: true,
        optional: true,
        disabled,
        color,
        tab: domainConstants.DocumentTab.Criteria,
        dossierId: beoordelingscriteria.dossierId
    };

    const ingespeeldOpNieuweOpkomendeDisciplinesIsTrue = (
        <div>
            <TextAreaInput
                {...sharedInputProps}
                tooltip={INNOVATIE_TOOLTIP}
                name="mateVanInnovatie"
                label="Innovatie (max. 2.000 tekens)"
                value={beoordelingscriteria.mateVanInnovatie}
                height={5}
                validationMessage={errors ? errors.mateVanInnovatie : ""}
                validationMessageType={validationMessageType} />
            <DownloadUploadFiles
                {...sharedDownloadProps}
                title="Innovatie"
                component={domainConstants.ComponentName.Innovatie}
                onDelete={mapDeleteFile(domainConstants.ComponentName.Innovatie)}
                onDrop={mapDropFiles(domainConstants.ComponentName.Innovatie)}
                files={getFilesForDossierComponent(domainConstants.ComponentName.Innovatie)}
                fileTypes={fileTypes.Innovatie}
                validationMessage={errors ? errors.ulInnovatie : ""}
                validationMessageType={validationMessageType}
                fileSessionStarted={fileSessionStarted} />
        </div>
    );
    const gebruikVanNieuweTechnologienIsTrue = (
        <div>
            <TextAreaInput
                {...sharedInputProps}
                name="nieuweTechnologien"
                label="Nieuwe technologieen (max. 2.000 tekens)"
                value={beoordelingscriteria.nieuweTechnologien}
                height={5}
                validationMessage={errors ? errors.nieuweTechnologien : ""}
                validationMessageType={validationMessageType} />
            <DownloadUploadFiles
                {...sharedDownloadProps}
                title="Nieuwe technologieën"
                component={domainConstants.ComponentName.NieuweTechnologieen}
                onDelete={mapDeleteFile(domainConstants.ComponentName.NieuweTechnologieen)}
                onDrop={mapDropFiles(domainConstants.ComponentName.NieuweTechnologieen)}
                files={getFilesForDossierComponent(domainConstants.ComponentName.NieuweTechnologieen)}
                fileTypes={fileTypes.NieuweTechnologieen}
                validationMessage={errors ? errors.ulNieuweTechnologieen : ""}
                validationMessageType={validationMessageType}
                fileSessionStarted={fileSessionStarted} />
        </div>
    );
    return (
        <Fieldset
            title="Kwaliteitsontwikkeling en innovatie">
            <FieldsetSubHeader>Toon aan in welke mate er belang gehecht wordt aan de kwaliteit van de topsportinfrastructuur: voldoende professioneel ingericht, voldoen aan internationale
                normen, aanwezigheid van een permanente infrastructuur en sporttakspecifiek en/of technologisch materiaal.</FieldsetSubHeader>
            <TextAreaInput
                {...sharedInputProps}
                name="mateWaarinBelanggehechtWordtAanKwaliteit"
                label="Kwaliteit (max. 2.000 tekens)"
                value={beoordelingscriteria.mateWaarinBelanggehechtWordtAanKwaliteit}
                height={5}
                validationMessage={errors ? errors.mateWaarinBelanggehechtWordtAanKwaliteit : ""}
                validationMessageType={validationMessageType} />

            <DownloadUploadFiles
                {...sharedDownloadProps}
                title="Kwaliteit"
                component={domainConstants.ComponentName.Kwaliteit}
                onDelete={mapDeleteFile(domainConstants.ComponentName.Kwaliteit)}
                onDrop={mapDropFiles(domainConstants.ComponentName.Kwaliteit)}
                files={getFilesForDossierComponent(domainConstants.ComponentName.Kwaliteit)}
                fileTypes={fileTypes.Kwaliteit}
                validationMessage={errors ? errors.ulKwaliteit : ""}
                validationMessageType={validationMessageType}
                fileSessionStarted={fileSessionStarted} />

            <FieldsetSubHeader>Wordt er ingespeeld op de beoefening van nieuwe of opkomende sporten/disciplines? Indien ja, benoem een geef toelichting.</FieldsetSubHeader>

            <RadioButtonChild
                {...sharedInputProps}
                label=""
                name="ingespeeldOpNieuweOpkomendeDisciplines"
                value={beoordelingscriteria.ingespeeldOpNieuweOpkomendeDisciplines}
                horizontal
                validationMessage={errors ? errors.ingespeeldOpNieuweOpkomendeDisciplines : ""}
                validationMessageType={validationMessageType}
                childJa={ingespeeldOpNieuweOpkomendeDisciplinesIsTrue}
            />
            <FieldsetSubHeader>Wordt er gebruik gemaakt van nieuwe technologieën, met het oog op een optimale topsportomgeving met de grootst mogelijke meerwaarde voor de
                Vlaamse topsporters en topsporttalenten?</FieldsetSubHeader>
            <RadioButtonChild
                {...sharedInputProps}
                label=""
                name="gebruikVanNieuweTechnologien"
                value={beoordelingscriteria.gebruikVanNieuweTechnologien}
                horizontal
                validationMessage={errors ? errors.gebruikVanNieuweTechnologien : ""}
                validationMessageType={validationMessageType}
                childJa={gebruikVanNieuweTechnologienIsTrue}
            />
        </Fieldset>
    );
};

KwaliteitsontwikkelingEnInnovatieForm.propTypes = {
    beoordelingscriteria: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    color: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    fileTypes: PropTypes.object,
    mapDeleteFile: PropTypes.func.isRequired,
    mapDropFiles: PropTypes.func.isRequired,
    getFilesForDossierComponent: PropTypes.func.isRequired,
    fileSessionStarted: PropTypes.bool,
    validationMessageType: PropTypes.string
};

export default KwaliteitsontwikkelingEnInnovatieForm;


